import React from "react";

import { Box, Divider, List, ListItem, Typography } from "@mui/material";

export default function AboutHistory(props) {
  // const nowMediaQuery = props.nowMediaQuery;
  return (
    <div className="section">
      <section className="contents">
        <Box mt={"150px"}>
          <Typography variant="h5" sx={{ my: 0 }} color="black">
            <strong className="blue">연혁</strong>
          </Typography>
          <List sx={{ p: 0 }}>
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2025년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    3월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 2025년 대학동 중장년 1인가구 지원사업 선정
                      <br />- 일상생활과 연계한 교육프로그램 및 건강한 여가·문화
                      체험 사업
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    2월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 해피인. 대학동주민센터. 지역사회보장협의체 지역
                      복지공동체 조성 업무협약
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2024년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    9월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 관악구 사회복지의 날 관악구청장 표창
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    3월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 해피인 ‘치매극복 선도단체’ 지정 (관악보건소
                      치매안심센터)
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    1월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 광주 동구청 공무원 및 복지관 직원 방문-독거 중장년
                      고립해결 방안 컨설팅
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2023년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    6월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 서울시복지재단 사회적고립 ‘연결’ 포럼 : 실천부분 해피인
                      사례 발표
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    5월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • ‘마을기업 준비 프로젝트’ 발표회
                    </Typography>
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 고독사 예방을 위한 자조조직으로서의 마을기업 방향 및
                      방법 연구 발표
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    4월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 기재부, 복지부, 관악구청, 복지연구원과 중장년
                      커뮤니티센터 필요성 등 논의
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    3월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 보건복지부 고독사 예방 및 관리 시범사업 현장 방문
                      <br />• 서울대 시각디자인과 협업 - ‘마을기업 준비
                      프로젝트’ 시행
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2022년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    12월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 한국사회복지학회 ‘취약 독거중장년들의 문제로 본
                      사회복지과제’ 발표
                      <br />
                      • 돌봄과 미래 정책 세미나 - ‘독거중장년 복지정책 과제’
                      발표
                      <br />
                      • 2022년 민관협치사업 성과공유회 - 해피인 지원사업 성과
                      발표
                      <br />
                      • 해피인 가족 자조공동체 ‘윗말협의회’ 조직
                      <br />
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    11월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 관악노동복지센터 ‘고시원거주 1인가구 노동정책’ 토론회
                      발표
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    10월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 오산시 민.관 복지기관 종사자 견학 방문- 고독사예방
                      중장년 지원 발표
                      <br />• 건강보험공단 서울본부 협업 - 건강검진 및
                      동행서비스 (40명)
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2021년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    11월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 한국주민운동 50주년 포럼 – 독거 중장년 복지지원 해피인
                      사례 주제 발표
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    9월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 서울대 시각디자인과 협업 - 해피인 가족 지원관리 앱
                      ‘안부신호등’ 개발
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    7월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 라파엘크리닉 연대 / 해피인가족 코로나백신 접종 (36명)
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    6월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • KT&G 남서울본부 도시락 등 후원 업무 협약 <br />• 해피인
                      가족간 네트워크. 홍보 등을 위한 단체카톡방 개설
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    5월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 서울시 1인가구TF팀, 관악구청 5개부서 및 민간단체 1인가구
                      지원방향 회의
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    3월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 코로나19로 월.수.금 도시락 나눔. 대화, 상담, 병원 동행,
                      자원 연대 등
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    2월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 주민 리더자 모임 시작 – 공동체조직 방향 논의
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2020년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    12월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 길벗사랑공동체 해피인 자체 고유번호증 발급
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    9월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 주거복지상담소 마을특화사업 참여 - 교육, 프로그램,
                      전시회 등
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    6월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 커뮤니티공간 해피친구들 개원(교육, 회의, 운동, 소모임
                      공간. 대학동 주거상담소 입소)
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    2월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17} mb={0.5}>
                      • 관악주거복지센터 국토부 주거상향 사업 연대. 해피인 가족
                      주거상담
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2017년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Typography variant="subtitle1" fontSize={17} width={"70px"}>
                    10월
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17}>
                      • 해피인 개원 (2017.10.16.)
                      <br />• 월~금 운영. 식사 및 차 나눔. 생활 문제 대화 및
                      상담. 사무기기 사용 지원
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
          </List>
        </Box>
      </section>
    </div>
  );
}
